import comp from "./ResourceViewModal";
export default comp;
